<!--suppress HtmlUnknownTag -->
<template>
  <div class="ordering">
    <div class="ordering__left">
      <slot name="logo" />

      <div class="ordering__top">
        <slot name="breadcrumbs" />
        <slot name="info" />
      </div>

      <div class="checkout">
        <CheckoutStep
          :current-step="step"
          :step-number="1"
          :images="[
            '/img/pyramid-ordering-1.png',
            '/img/pyramid-ordering-1.png',
          ]"
        >
          <template #header>
            <div class="ordering__step-title">
              {{ checkoutLanguage["step_1_title"] }}
            </div>
            <div class="ordering__step-subtitle">
              {{ checkoutLanguage.undertitle_1 }}
            </div>
          </template>

          <template #form>
            <form
              class="ordering__form ordering__form_first"
              @submit.prevent="handleFirstStep"
            >
              <div class="ordering__form-title">
                {{ checkoutLanguage.info }}
              </div>
              <input
                v-model="checkoutData.email"
                type="email"
                required
                name="checkoutData[email]"
                class="ordering__form-item"
                :class="{ error: errors.email }"
                :placeholder="checkoutLanguage.email"
                @change="validateEmail"
              >
              <input
                v-model="checkoutData.firstname"
                type="text"
                required
                name="checkoutData[firstname]"
                :pattern="latinPattern"
                :title="checkoutLanguage.field_pattern"
                :placeholder="checkoutLanguage.firstname"
                class="ordering__form-item ordering__form-item_name"
                @change="saveData"
              >
              <input
                v-model="checkoutData.secondname"
                type="text"
                required
                name="checkoutData[secondname]"
                :pattern="latinPattern"
                :title="checkoutLanguage.field_pattern"
                :placeholder="checkoutLanguage.lastname"
                class="ordering__form-item ordering__form-item_surname"
                @change="saveData"
              >

              <button
                class="btn btn__primary"
                type="submit"
              >
                {{ checkoutLanguage.confirm }}
              </button>
            </form>
          </template>
          <template #filled>
            <div class="ordering__passed">
              <div class="ordering__passed-contact">
                <div class="ordering__passed-contact-title">
                  {{ checkoutLanguage.contact }}
                </div>
                <div class="ordering__passed-contact-text">
                  {{ checkoutData.secondname }} {{ checkoutData.firstname }},
                  {{ checkoutData.email }}
                </div>
              </div>
              <button
                class="ordering__passed-change"
                @click="() => goto(1)"
              >
                {{ checkoutLanguage.change }}
              </button>
            </div>
          </template>
        </CheckoutStep>

        <CheckoutStep
          :current-step="step"
          :step-number="2"
          :images="[
            '/img/pyramid-ordering-2.png',
            '/img/pyramid-ordering-1-2.png',
          ]"
        >
          <template #header>
            <div class="ordering__step-title">
              {{ checkoutLanguage["step_2_title"] }}
            </div>
            <div class="ordering__step-subtitle">
              {{ checkoutLanguage.undertitle_2 }}
            </div>
          </template>

          <template #form>
            <form
              class="ordering__form ordering__form_second"
              @submit.prevent="handleSecondStep"
            >
              <div class="ordering__form-client">
                <label class="base-control"><input
                  v-model="checkoutData.legal"
                  name="checkoutData[legal]"
                  :pattern="latinPattern"
                  :title="checkoutLanguage.field_pattern"
                  required
                  value="customer"
                  type="radio"
                  @change="changeCompany"
                >{{ checkoutLanguage.house }}</label>
                <label class="base-control"><input
                  v-model="checkoutData.legal"
                  name="checkoutData[legal]"
                  :pattern="latinPattern"
                  :title="checkoutLanguage.field_pattern"
                  required
                  value="company"
                  type="radio"
                  checked
                  @change="changeCompany"
                >{{ checkoutLanguage.company }}</label>
              </div>
              <input
                v-show="checkoutData.legal === 'company'"
                v-model="checkoutData.companyName"
                :disabled="checkoutData.legal === 'customer'"
                :pattern="latinPattern"
                :title="checkoutLanguage.field_pattern"
                type="text"
                class="ordering__form-item"
                name="checkoutData[companyName]"
                required
                :placeholder="checkoutLanguage['company_name']"
                maxlength="35"
                @change="saveData"
              >

              <select
                v-model="checkoutData.country"
                class="ordering__form-item"
                name="checkoutData[country]"
                required
                @change="saveShippingAddress"
              >
                <option
                  value=""
                  disabled
                >
                  {{ checkoutLanguage.country }}
                </option>
                <option
                  v-for="country in deliverySortCountries"
                  :key="country.id"
                  :value="country.id"
                >
                  {{ country.name }}
                </option>
              </select>
              <select
                v-if="
                  selectedDeliveryCountry &&
                    selectedDeliveryCountry.isZonesEnabled
                "
                v-model="checkoutData.zone_id"
                class="ordering__form-item"
                name="checkoutData[zone_id]"
                required
                @change="saveShippingZoneId"
              >
                <option
                  value=""
                  disabled
                >
                  State
                </option>
                <option
                  v-for="zone in zones"
                  :key="zone.id"
                  :value="zone.id"
                >
                  {{ zone.name }}
                </option>
              </select>

              <input
                v-model="checkoutData.address"
                type="text"
                class="ordering__form-item ordering__form-item_half-left"
                :class="{ error: errors.address }"
                name="checkoutData[address]"
                required
                :pattern="latinPattern"
                :title="checkoutLanguage.field_pattern"
                :placeholder="checkoutLanguage['address']"
                maxlength="60"
                @change="() => validateAddress()"
              >

              <input
                v-model="checkoutData.house"
                type="text"
                maxlength="8"
                class="ordering__form-item ordering__form-item_half-right"
                name="checkoutData[house]"
                required
                :pattern="latinPattern"
                :title="checkoutLanguage.field_pattern"
                :placeholder="checkoutLanguage['house_number']"
                @change="saveData"
              >

              <label class="order-error ordering__form-item_half-left">
                <span
                  v-show="errors.postal"
                  class="order-error__message"
                >Example: {{ postalExample }}</span>
                <input
                  v-model="checkoutData.postal"
                  type="text"
                  class="ordering__form-item order-error__input"
                  :class="{ error: errors.postal }"
                  name="checkoutData[postal]"
                  required
                  :placeholder="checkoutLanguage['postcode']"
                  @change="() => validatePostal()"
                >
              </label>

              <input
                v-model="checkoutData.city"
                type="text"
                class="ordering__form-item ordering__form-item_half-right"
                :class="{ error: errors.city }"
                name="checkoutData[city]"
                required
                :pattern="latinPattern"
                :title="checkoutLanguage.field_pattern"
                :placeholder="checkoutLanguage['city']"
                @change="() => validateCity()"
              >

              <div class="ordering__text">
                {{ checkoutLanguage.phone_requirement }}
              </div>

              <vue-tel-input
                v-model="checkoutData.phone"
                class="ordering__phone-wrap"
                mode="international"
                :input-options="{
                  showDialCode: true,
                  required: true,
                  type: 'tel',
                  styleClasses: {
                    'ordering__form-item': true,
                    error: errors.phone,
                  },
                  name: 'checkoutData[phone]',
                  maxlength: 20
                }"
                :valid-characters-only="true"
                @change="validatePhone"
              />

              <label
                v-show="false"
                class="ordering__form-item-label"
              >
                <input
                  v-model="checkoutData.allowSaveData"
                  type="checkbox"
                  name="checkoutData[allowSaveData]"
                  value="true"
                >
                {{ checkoutLanguage["save_my_info"] }}
              </label>

              <button
                class="btn btn__primary"
                type="submit"
              >
                {{ checkoutLanguage.confirm }}
              </button>
            </form>
          </template>
          <template #filled>
            <div class="ordering__passed">
              <div class="ordering__passed-contact">
                <div class="ordering__passed-contact-title">
                  {{ checkoutLanguage.delivery_to }}
                </div>
                <div class="ordering__passed-contact-text">
                  {{ secondStepMessage }}
                </div>
              </div>
              <button
                class="ordering__passed-change"
                :disabled="!hasProducts"
                @click="() => goto(2)"
              >
                {{ checkoutLanguage.change }}
              </button>
            </div>
          </template>
        </CheckoutStep>

        <CheckoutStep
          :current-step="step"
          :step-number="3"
          :images="[
            '/img/pyramid-ordering-3.png',
            '/img/pyramid-ordering-1-3.png',
          ]"
        >
          <template #header>
            <div class="ordering__step-title">
              {{ checkoutLanguage["step_3_title"] }}
            </div>
            <div class="ordering__step-subtitle">
              {{ checkoutLanguage.undertitle_3 }}
            </div>
          </template>

          <template #form>
            <form
              class="ordering__form ordering__form_third"
              @submit="handleThirdStep"
            >
              <div class="ordering__form-title">
                {{ checkoutLanguage.delivery }}
              </div>
              <div
                v-for="shippingMethod in shippingMethods"
                :key="shippingMethod.code"
                class="ordering__form-item"
              >
                <label class="base-control"><input
                  v-model="checkoutData.shipping"
                  :value="shippingMethod.code"
                  type="radio"
                  name="checkoutData[shipping]"
                  @change="handleChangeShipping"
                >{{ shippingMethod.title }}</label>
                <div class="ordering__form-price">
                  {{ shippingMethod.text }}
                </div>
              </div>

              <div class="ordering__form-title">
                {{ checkoutLanguage.payment }}
                <div class="ordering__form-subtitle">
                  {{ checkoutLanguage["payment_undertitle"] }}
                </div>
              </div>
              <div
                v-for="paymentMethod in paymentMethods"
                :key="paymentMethod.code"
                class="ordering__form-item"
              >
                <label class="base-control">
                  <input
                    v-model="checkoutData.payment"
                    :value="paymentMethod.code"
                    type="radio"
                    name="checkoutData[payment]"
                    @change="changePaymentMethod"
                  >
                  <img
                    v-if="paymentMethod.icon"
                    :src="paymentMethod.icon"
                    alt="Логотип"
                  >
                  {{ paymentMethod.title }}
                </label>

                <!--                <div v-html="paymentMethod.titleHtml" />-->
              </div>

              <div class="ordering__form-title">
                {{ checkoutLanguage["payment_address"] }}
                <div class="ordering__form-subtitle">
                  {{ checkoutLanguage["payment_address_undertitle"] }}
                </div>
              </div>
              <div
                v-if="hasProducts"
                class="ordering__form-item"
              >
                <label class="base-control"><input
                  v-model="checkoutData.paymentAddressIsIdentical"
                  :value="true"
                  name="checkoutData[paymentAddressIsIdentical]"
                  type="radio"
                  @change="saveData"
                >{{ checkoutLanguage.identical }}</label>
              </div>
              <div class="ordering__form-item">
                <label class="base-control"><input
                  v-model="checkoutData.paymentAddressIsIdentical"
                  :value="false"
                  name="checkoutData[paymentAddressIsIdentical]"
                  type="radio"
                  @change="saveData"
                >{{ checkoutLanguage.different }}</label>
              </div>

              <input
                v-show="!checkoutData.paymentAddressIsIdentical"
                v-model="checkoutData.paymentAddress"
                :disabled="checkoutData.paymentAddressIsIdentical"
                type="text"
                class="ordering__form-item"
                :class="{ error: errors.paymentAddress }"
                name="checkoutData[paymentAddress]"
                required
                :pattern="latinPattern"
                :title="checkoutLanguage.field_pattern"
                :placeholder="checkoutLanguage['address']"
                @change="() => validateAddress(true)"
              >

              <select
                v-show="!checkoutData.paymentAddressIsIdentical"
                v-model="checkoutData.paymentCountry"
                :disabled="checkoutData.paymentAddressIsIdentical"
                class="ordering__form-item"
                name="checkoutData[paymentCountry]"
                required
                @change="changePaymentAddressIsIdentical"
              >
                <option
                  value=""
                  disabled
                >
                  {{ checkoutLanguage.country }}
                </option>
                <option
                  v-for="country in paymentCountries"
                  :key="country.id"
                  :value="country.id"
                >
                  {{ country.name }}
                </option>
              </select>

              <input
                v-show="!checkoutData.paymentAddressIsIdentical"
                v-model="checkoutData.paymentHouse"
                :disabled="checkoutData.paymentAddressIsIdentical"
                type="text"
                class="ordering__form-item ordering__form-item_house"
                name="checkoutData[paymentHouse]"
                required
                :pattern="latinPattern"
                :title="checkoutLanguage.field_pattern"
                :placeholder="checkoutLanguage['house_number']"
                @change="saveData"
              >
              <input
                v-show="!checkoutData.paymentAddressIsIdentical"
                v-model="checkoutData.paymentPostal"
                :disabled="checkoutData.paymentAddressIsIdentical"
                type="text"
                class="ordering__form-item ordering__form-item_postal"
                :class="{ error: errors.paymentPostal }"
                name="checkoutData[paymentPostal]"
                required
                :placeholder="checkoutLanguage['postcode']"
                @change="() => validatePostal(true)"
              >
              <input
                v-show="!checkoutData.paymentAddressIsIdentical"
                v-model="checkoutData.paymentCity"
                :disabled="checkoutData.paymentAddressIsIdentical"
                type="text"
                class="ordering__form-item ordering__form-item_city"
                :class="{ error: errors.paymentCity }"
                name="checkoutData[paymentCity]"
                required
                :pattern="latinPattern"
                :title="checkoutLanguage.field_pattern"
                :placeholder="checkoutLanguage['city']"
                @change="() => validateCity(true)"
              >

              <label
                class="ordering__form-item ordering__form-item_agreement base-control"
              >
                <input
                  type="checkbox"
                  required
                  value="1"
                  name="agreement"
                >
                <a
                  href="/privacy"
                  target="_blank"
                  class="a-none"
                ><u>{{ checkoutLanguage.agreement }}</u></a>
              </label>

              <button class="btn btn__primary">
                {{ checkoutLanguage.confirm }}
              </button>
            </form>
          </template>
        </CheckoutStep>

        <div
          v-once
          ref="dynamic-payment-form"
        />
      </div>

      <slot name="footer" />
    </div>

    <div class="ordering__right">
      <div class="ordering-summary">
        <div v-html="productsHtml" />

        <slot name="coupon" />

        <div
          v-for="discount in discountInfo"
          :key="discount.code + '_' + discount.title"
          :class="classCartTable('coupon-price')"
        >
          <div>{{ discount.title }}</div>
          <div
            :class="
              classCartTable('coupon-price-total', {
                accent:
                  discount.code === 'discount' || discount.code === 'save',
              })
            "
          >
            {{ discount.text }}
          </div>
        </div>

        <div
          v-for="total in totals"
          :key="total.code"
          :class="classCartTable('coupon-price')"
        >
          <div>
            <b
              v-if="total.code === 'total'"
              class="ordering__black-text"
            >{{
              total.title
            }}</b>
            <template v-else>
              {{ total.title }}
            </template>
          </div>
          <div :class="classCartTable('coupon-price-total')">
            <b
              v-if="total.code === 'total'"
              class="ordering__black-text"
            >{{
              total.text
            }}</b>
            <template v-else>
              {{ total.text }}
            </template>
          </div>
        </div>
      </div>

      <slot name="advantages" />
    </div>

    <div class="ordering-mobile js-tooltip">
      <div class="ordering-mobile__top">
        <slot name="tooltip-btn" />
        <div class="ordering-mobile__price-total">
          {{ totals[totals.length - 1].text }}
        </div>
      </div>

      <div class="ordering-mobile__bottom js-tooltip-content active">
        <slot name="order-summary-top-mobile" />

        <template v-for="discount in discountInfo">
          <div
            :key="discount.code + '_title'"
            class="ordering-mobile__subtitle"
          >
            {{ discount.title }}
          </div>
          <div
            :key="discount.code + '_value'"
            :class="
              classMobileOrder('price', {
                accent:
                  discount.code === 'discount' || discount.code === 'save',
              })
            "
          >
            {{ discount.text }}
          </div>
        </template>

        <template v-for="total in totals.slice(0, -1)">
          <div
            :key="total.code + '_subtitle'"
            class="ordering-mobile__subtitle"
          >
            <b
              v-if="total.code === 'total'"
              class="ordering__black-text"
            >{{
              total.title
            }}</b>
            <template v-else>
              {{ total.title }}
            </template>
          </div>
          <div
            :key="total.code + '_text'"
            class="ordering-mobile__price"
          >
            <b
              v-if="total.code === 'total'"
              class="ordering__black-text"
            >{{
              total.text
            }}</b>
            <template v-else>
              {{ total.text }}
            </template>
          </div>
        </template>

        <div class="ordering-mobile__line ordering-mobile__line-mt" />

        <div class="ordering-mobile__subtitle">
          {{ totals[totals.length - 1].title }}
        </div>
        <div class="ordering-mobile__price-total">
          {{ totals[totals.length - 1].text }}
        </div>
      </div>
    </div>

    <!--    <div
      class="ordering__totals-button ordering__totals-button-mobile"
    >
      <button
        class="btn btn__primary"
        :disabled="saveOrderIsDisabled"
        @click="saveOrder"
      >
        Zamówienie zostało potwierdzone
      </button>
    </div>-->
  </div>
</template>

<script>
import CheckoutStep from './checkout-step'
import {
  fetchDiscountInfo,
  fetchPaymentMethods,
  fetchShippingMethods,
  fetchTotals,
  fetchZones,
  getProductsCartQuantity,
  loadProducts,
  saveAdmitadUser,
  saveCheckoutData,
  saveShippingAddress,
  saveShippingMethod,
  saveUser,
} from '@/app/js/checkout-api'
import { fetchCountries, fetchStoreCountries } from '@/app/js/api/countries'
import { initCoupons } from '@/app/js/coupon'
import { initDefaultTooltips } from '@/app/js/default-tooltip'
import { loadScript } from '@/app/js/helpers/loadScript'
import { analytics } from '@/app/js/analytics'
import { cart } from '@/app/js/cart'
import { cn } from '@/app/js/classname'
import { vMaska } from 'maska'
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import {initApplyVouchers} from '@/app/js/apply-voucher'

const classCartTable = cn('shopping-cart-table')
const classMobileOrder = cn('ordering-mobile')

const LATIN_PATTERN = /[\w\u00c0-\u017e\s\u0021-\u007E]+/

const DEFAULT_POSTCODE_PATTERN = /^\d{4,6}$|^\d{2,4}[\s.-]*?\d{2,4}$/

function getAnalyticsItems() {
  return cart.fetchCart('products', []).then((response) => {
    return response.data.items.map((item) => {
      return {
        item_id: item.product_id,
        item_name: item.name,
        price: item.price,
      }
    })
  })
}

export default {
  name: 'CheckoutPage',
  components: {
    VueTelInput,
    CheckoutStep,
  },
  directives: { maska: vMaska },
  inject: ['checkoutLanguage'],
  props: {
    currentCountryId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      latinPattern: LATIN_PATTERN.toString().slice(1, -1),
      step: 1,
      deliveryCountries: {},
      deliverySortCountries: [],
      paymentCountries: {},
      zones: {},
      checkoutData: {
        email: '',
        firstname: '',
        secondname: '',
        legal: 'customer',
        companyName: '',
        address: '',
        house: '',
        postal: '',
        city: '',
        country: '',
        zone_id: '',
        phone: '',
        shipping: '',
        shippingCost: '',
        shippingTitle: '',
        payment: '',
        paymentAddressIsIdentical: 'true',
        paymentAddress: '',
        paymentHouse: '',
        paymentPostal: '',
        paymentCity: '',
        paymentCountry: '',
        allowSaveData: 'true',
      },
      shippingMethods: {},
      paymentMethods: {},
      errors: {},
      saveOrderIsDisabled: true,
      totals: [
        {
          text: '',
          title: '',
        },
      ],
      discountInfo: [
        {
          text: '',
          title: '',
          code: '',
          value: '',
        },
      ],
      productsHtml: '',
      hasProducts: false
    }
  },
  computed: {
    secondStepMessage() {
      if (!this.hasProducts) {
        return this.checkoutLanguage.no_address_required
      }
      let message = ''
      if (this.checkoutData.legal === 'company') {
        message += this.checkoutData.companyName + ', '
      }

      message += `${this.checkoutData.postal}, ${this.checkoutData.address} ${this.checkoutData.house},  ${this.checkoutData.city},  ${this.selectedDeliveryCountry?.name},  ${this.checkoutData.phone}`

      return message
    },
    selectedDeliveryCountry() {
      return this.deliveryCountries[this.checkoutData.country]
    },
    selectedPaymentCountry() {
      return this.paymentCountries[this.checkoutData.paymentCountry]
    },
    selectedPaymentMethod() {
      return this.paymentMethods[this.checkoutData.payment]
    },
    selectedShippingMethod() {
      return this.shippingMethods[this.checkoutData.shipping]
    },
    hasError() {
      let hasError = false

      for (const error in this.errors) {
        if (this.errors[error]) {
          hasError = true
        }
      }

      return hasError
    },
    postalExample() {
      return (
        this.deliveryCountries[this.checkoutData.country]?.postalExample ||
        '1234'
      )
    },
  },
  watch: {
    step: {
      handler(val) {
        sessionStorage.setItem('step', val)
      },
      deep: true,
    },
  },
  mounted() {
    initCoupons()
    initDefaultTooltips()
    initApplyVouchers()
  },
  async created() {
    this.checkSavedData()
    await Promise.all([
      this.loadPaymentCountries(),
      this.loadDeliveryCountries()
        .then(() => this.loadZones())
        .then(() => this.saveShippingZoneId()),
      this.loadProducts(),
      this.loadDiscountInfo(),
      this.checkHasProducts()
    ])

    await this.restoreSavedStep()

    // const updateTimer = setInterval(() => {
    //   this.loadProducts()
    //   this.loadTotals()
    // }, 5000)
    //
    // window.stopCheckoutUpdating = () => clearInterval(updateTimer)
  },
  methods: {
    async restoreSavedStep() {
      const step = sessionStorage.step
      if (step) {
        if (step > 1) {
          await this.handleFirstStep()
        }
        if (step > 2) {
          await this.handleSecondStep()
        }
      }
    },
    goto(step) {
      this.saveOrderIsDisabled = true
      this.errors = {}
      this.step = step
    },
    async checkHasProducts() {
      const resp = await getProductsCartQuantity()
      this.hasProducts = resp?.quantity > 0
    },
    async handleFirstStep() {
      this.validateEmail()
      if (this.hasError) {
        return
      }

      this.saveData()
      if (this.hasProducts) {
        this.goto(2)
      } else {
        this.goto(3)
        this.checkoutData.paymentAddressIsIdentical = false
        await this.loadCheckoutData()
      }

      await this.loadProducts()
      analytics.checkoutPersonalInfoInserted()
    },
    async handleSecondStep() {
      this.validatePhone()
      this.validatePostal()
      this.validateAddress()

      if (this.hasError) {
        return
      }

      this.saveData()

      await saveUser(this.constructRequestData())
      saveAdmitadUser(this.constructRequestData())

      this.goto(3)

      this.loadCheckoutData()

      analytics.deliveryAddressConfirmed()
    },
    handleThirdStep(e) {
      e.preventDefault()

      this.validatePostal(true)
      this.validateAddress(true)
      if (this.hasProducts && this.hasError) {
        return
      }

      this.saveData()
      this.loadProducts()
      this.goto(4)

      // this.saveOrderIsDisabled = false

      window.loadingOverlay.show()

      this.saveOrder().then((response) => {
        this.goToPayment(response)
      })
    },
    async handleChangeShipping() {
      this.saveData()

      const analyticsItems = await getAnalyticsItems()
      analytics.addShippingInfo(
        this.shippingMethods[this.checkoutData.shipping],
        analyticsItems
      )

      await saveShippingMethod(this.constructRequestData())

      this.loadTotals()
      this.loadDiscountInfo()
      this.loadProducts()
    },
    saveData() {
      localStorage.setItem(
        'escapeweltCheckoutData',
        JSON.stringify(this.checkoutData)
      )
    },
    removeData() {
      localStorage.removeItem('escapeweltCheckoutData')
    },
    async loadCheckoutData() {
      const request = this.constructRequestData()

      const analyticsItems = await getAnalyticsItems()

      const paymentPromise = fetchPaymentMethods(request).then((response) => {
        let firstPayment = null
        const paymentMethods = {}

        for (const [, paymentMethod] of Object.entries(response.data)) {
          if (firstPayment === null) {
            firstPayment = paymentMethod
          }

          paymentMethods[paymentMethod.code] = {
            code: paymentMethod.code,
            title: paymentMethod.title,
            titleHtml: '',
            icon: paymentMethod.icon,
          }
        }

        this.paymentMethods = paymentMethods
        if (!this.paymentMethods[this.checkoutData.payment]) {
          this.checkoutData = {
            ...this.checkoutData,
            payment: firstPayment.code,
          }
        }

        analytics.addPaymentInfo(
          this.paymentMethods[this.checkoutData.payment],
          analyticsItems
        )

        this.sendPaymentMethodToAnalytics()
      })

      const shippingPromise = fetchShippingMethods(request).then((response) => {
        let firstShipping = null
        const shippingMethods = {}

        for (const [, shippingMethod] of Object.entries(response.data)) {
          for (const [, quote] of Object.entries(shippingMethod.quote)) {
            if (firstShipping === null) {
              firstShipping = quote
            }

            shippingMethods[quote.code] = {
              ...quote,
              taxClassId: quote.tax_class_id,
            }
          }
        }

        this.shippingMethods = shippingMethods
        if (!this.shippingMethods[this.checkoutData.shipping]) {
          this.checkoutData = {
            ...this.checkoutData,
            shipping: firstShipping.code,
          }
        }

        analytics.addShippingInfo(
          this.shippingMethods[this.checkoutData.shipping],
          analyticsItems
        )
      })

      await Promise.all([paymentPromise, shippingPromise])

      await saveShippingMethod(this.constructRequestData())

      this.loadTotals()
      this.loadDiscountInfo()
      this.loadProducts()
    },
    async loadPaymentCountries() {
      const countries = await fetchCountries()

      this.paymentCountries = Object.fromEntries(
        countries.map((country) => [country.id, country])
      )

      if (!this.paymentCountries[this.checkoutData.paymentCountry]) {
        if (this.paymentCountries[this.currentCountryId]) {
          this.checkoutData.paymentCountry = this.currentCountryId.toString()
        } else {
          this.checkoutData.paymentCountry = countries[0].id
        }
      }
    },
    async loadDeliveryCountries() {
      const countries = await fetchStoreCountries()

      this.deliverySortCountries = countries
      this.deliveryCountries = Object.fromEntries(
        countries.map((country) => [country.id, country])
      )

      if (!this.deliveryCountries[this.checkoutData.country]) {
        if (this.deliveryCountries[this.currentCountryId]) {
          this.checkoutData.country = this.currentCountryId.toString()
        } else {
          this.checkoutData.country = countries[0].id
        }
      }
    },
    loadZones() {
      return fetchZones(this.checkoutData.country).then((response) => {
        const zones = {}
        const deliveryCountry = this.deliverySortCountries[this.checkoutData.country]
        const isZonesEnabled = !!deliveryCountry?.isZonesEnabled
        let firstZone = null

        for (const [, zone] of Object.entries(response.data)) {
          zones[zone.id] = {
            id: zone.id,
            name: zone.name,
            isoCode: zone.iso_code,
            postalRegex: zone.postal_regex,
            postalExample: zone.postal_example,
          }

          if (firstZone === null && isZonesEnabled) {
            firstZone = { ...zones[zone.id] }
          }
        }

        this.zones = zones

        if (this.zones[this.checkoutData.zone_id] === undefined) {
          this.checkoutData.zone_id = firstZone?.id || 0
        }
      })
    },
    loadTotals() {
      return fetchTotals().then((response) => {
        this.totals = response.data.totals
      })
    },
    loadDiscountInfo() {
      return fetchDiscountInfo().then((response) => {
        this.discountInfo = response.data
      })
    },
    classCartTable,
    classMobileOrder,
    async loadProducts() {
      const response = await loadProducts()
      this.productsHtml = response.data
    },
    checkSavedData() {
      if (!localStorage.getItem('escapeweltCheckoutData')) {
        this.saveData()
        return
      }

      this.checkoutData = {
        ...this.checkoutData, // save the structure
        ...JSON.parse(localStorage.getItem('escapeweltCheckoutData')), // and refill data
      }
    },
    saveOrder() {
      this.saveOrderIsDisabled = true

      return saveCheckoutData(this.constructRequestData())
    },
    async goToPayment(response) {
      if (response.data.success) {
        if (!this.checkoutData.allowSaveData) {
          this.removeData()
        }

        if (!response.data.data) {
          console.error('Payment error. No payment data from server.')
          return
        }

        try {
          await this.fireGoalGoPurchase(response.data.orderData)
          this.executePaymentFormCode(response.data.data)
        } catch (e) {
          console.error(e)
        }
      } else {
        console.error('Save checkout error: response success is false.')

        if (response.data.redirect) {
          location.assign(response.data.redirect.replace(/&amp;/g, '&'))
        }
      }
    },
    async fireGoalGoPurchase(data) {
      try {
        const analyticsItems = await getAnalyticsItems()
        analytics.goToPurchase(analyticsItems, {
          id: data.order_id,
          total: data.total,
          tax: data.tax,
          shipping: data.shipping,
          coupon: data.coupon,
          currency: data.currency,
        })
      } catch (e) {
        //
      }
    },
    async executePaymentFormCode(paymentData) {
      for (const src of paymentData.scripts) {
        await loadScript(src)
      }

      // TODO rewrite all using payment methods to not send js to client
      // It uses jQuery and it's bad. But there is a reason why:
      // We need to execute js code that we get from payment method.
      // Native innerHtml doesn't run it. Of course we can use polyfill, but payment methods depends on jQuery too,
      // so I don't see any reason to avoid using jQuery here,
      // before we don't rewrite payment methods code
      $(this.$refs['dynamic-payment-form']).html(paymentData.formCode)
      const button = this.$refs['dynamic-payment-form'].querySelector(
        'input[type=submit],input[type=button],button,#button-confirm'
      )
      if (button) {
        button.click()

        setTimeout(() => {
          window.loadingOverlay.hide()
        }, 5000)
      } else {
        window.loadingOverlay.hide()
      }
    },
    constructRequestData() {
      const request = JSON.parse(JSON.stringify(this.checkoutData))

      request.paymentTitle = this.selectedPaymentMethod?.title

      request.shippingTitle = this.selectedShippingMethod?.title
      request.shippingCost = this.selectedShippingMethod?.cost
      request.taxClassId = this.selectedShippingMethod?.taxClassId

      request.shippingCountryName = this.selectedDeliveryCountry?.name

      if (request.paymentAddressIsIdentical) {
        request.paymentAddress = request.address
        request.paymentHouse = request.house
        request.paymentPostal = request.postal
        request.paymentCity = request.city
        request.paymentCountry = request.country
        request.paymentCountryName = this.selectedPaymentCountry?.name
      } else {
        request.paymentCountryName = this.selectedPaymentCountry?.name
      }

      return request
    },
    validatePhone() {
      this.errors = {
        ...this.errors,
        phone: false,
      }

      const phoneNumber = parsePhoneNumberFromString(this.checkoutData.phone)
      const isValidPhone = phoneNumber ? phoneNumber.isValid() : false

      if (isValidPhone) {
        this.saveData()
      } else {
        this.errors = {
          ...this.errors,
          phone: true,
        }
      }
    },
    validateEmail() {
      this.errors = {
        ...this.errors,
        email: false,
      }
      const regex = new RegExp(
        /^\w+([-+.']\w*)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      )

      if (regex.test(this.checkoutData.email)) {
        this.saveData()
      } else {
        this.errors = {
          ...this.errors,
          email: true,
        }
      }
    },
    validatePostal(payment = false) {
      if (payment) {
        if (this.checkoutData.paymentAddressIsIdentical) {
          return
        }

        this.errors = {
          ...this.errors,
          paymentPostal: false,
        }

        const regex = this.selectedPaymentCountry.postalRegex
          ? new RegExp(this.selectedPaymentCountry.postalRegex, 'i')
          : DEFAULT_POSTCODE_PATTERN

        if (regex.test(this.checkoutData.paymentPostal)) {
          this.saveData()
        } else {
          this.errors = {
            ...this.errors,
            paymentPostal: true,
          }
        }
      } else {
        this.errors = {
          ...this.errors,
          postal: false,
        }

        const regex = this.selectedDeliveryCountry.postalRegex
          ? new RegExp(this.selectedDeliveryCountry.postalRegex, 'i')
          : DEFAULT_POSTCODE_PATTERN

        if (regex.test(this.checkoutData.postal)) {
          this.saveData()
        } else {
          this.errors = {
            ...this.errors,
            postal: true,
          }
        }
      }
    },
    validateAddress(payment = false) {
      const regex = new RegExp(/^(.(\s*)?){5,120}$/)

      if (payment) {
        this.errors = {
          ...this.errors,
          paymentAddress: false,
        }

        if (regex.test(this.checkoutData.paymentAddress)) {
          this.saveData()
        } else if (!this.checkoutData.paymentAddressIsIdentical) {
          this.errors = {
            ...this.errors,
            paymentAddress: true,
          }
        }
      } else {
        this.errors = {
          ...this.errors,
          address: false,
        }

        if (regex.test(this.checkoutData.address)) {
          this.saveData()
        } else {
          this.errors = {
            ...this.errors,
            address: true,
          }
        }
      }
    },
    validateCity(payment = false) {
      const regex = new RegExp(/^(.(\s*)?){2,50}$/)

      if (payment) {
        this.errors = {
          ...this.errors,
          paymentCity: false,
        }

        if (regex.test(this.checkoutData.paymentCity)) {
          this.saveData()
        } else if (!this.checkoutData.paymentAddressIsIdentical) {
          this.errors = {
            ...this.errors,
            paymentCity: true,
          }
        }
      } else {
        this.errors = {
          ...this.errors,
          city: false,
        }

        if (regex.test(this.checkoutData.city)) {
          this.saveData()
        } else {
          this.errors = {
            ...this.errors,
            city: true,
          }
        }
      }
    },
    changeCompany() {
      this.saveData()

      if (this.checkoutData.legal === 'company') {
        analytics.companyPersonChecked()
      } else {
        analytics.privatePersonChecked()
      }
    },
    changePaymentMethod() {
      this.saveData()

      this.sendPaymentMethodToAnalytics()
    },
    changePaymentAddressIsIdentical() {
      this.saveData()

      analytics.changePaymentAddressIsIdentical()
    },
    sendPaymentMethodToAnalytics() {
      let method = 'undefined'

      if (this.checkoutData.payment === 'pp_standard') {
        method = analytics.PAYMENT_METHODS.PAYPAL
      }

      if (this.checkoutData.payment === 'stripe') {
        method = analytics.PAYMENT_METHODS.STRIPE
      }

      if (this.checkoutData.payment === 'amazon_login_pay') {
        method = analytics.PAYMENT_METHODS.AMAZON
      }

      analytics.paymentMethodSelected(method)
    },
    saveShippingAddress() {
      this.saveData()

      return saveShippingAddress(this.constructRequestData())
        .then(() => this.loadZones())
        .then(() => saveShippingAddress(this.constructRequestData()))
        .then((response) => {
          this.totals = response.data['totals']
        })
    },
    saveShippingZoneId() {
      this.saveData()

      return saveShippingAddress(this.constructRequestData()).then(
        (response) => {
          this.totals = response.data['totals']
        }
      )
    },
  },
}
</script>

<style lang="scss">
.order-error {
  position: relative;

  &__message {
    position: absolute;
    top: calc(100% + 5px);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    padding-right: 10px;
    padding-left: 10px;
    color: #fff;
    font-size: 14px;
    background-color: #e0b453;
    border-radius: 6px;
  }

  &__input {
    width: 100%;
  }
}
</style>
